<script>

    let { item } = $props();

</script>

{#if item.name}
    <h4 class='title'>
        {item.name}
    </h4>
{/if}

<style>

    h4.title {
        margin: 1.5rem 0 0.5rem 0;
        font-size: 1.1rem;
    }

</style>
